import React from 'react';
import { useDispatch } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getAccount } from '../firebase';
import { setCurrentLanguage, setDashboardLink } from '../features/app/appSlice';

const useAuthChanged = (setCurrentUser, setLoggedInAccountType) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (document.cookie.includes('lang=en')) {
      dispatch(setCurrentLanguage('en'));
    } else if (document.cookie.includes('lang=cy')) {
      dispatch(setCurrentLanguage('cy'));
    } else {
      document.cookie = '_ga_0700LVV1G5=; Max-Age=-99999999;';
    }

    onAuthStateChanged(auth, (user) => {
      // eslint-disable-next-line no-unused-vars
      user?.getIdToken().then((idToken) => {});
      setCurrentUser(user);
      if (user !== null) {
        getAccount()
          .then((response) => {
            const { data } = response;
            let dashboardLinkValue = '/dashboardHub/dashboard-pmc';
            if (data?.account_type === 'Property Management Company') {
              dashboardLinkValue = '/dashboardHub/dashboard-pmc';
            } else if (data?.account_type === 'Landlord') {
              dashboardLinkValue = '/dashboardHub/dashboard';
            } else if (data?.account_type === 'Installer') {
              dashboardLinkValue = '/installer/claim-grant/installer-dashboard';
            } else {
              dashboardLinkValue = '/dashboardHub/dashboard-pmc';
            }
            dispatch(setDashboardLink(dashboardLinkValue));
            setLoggedInAccountType(data.account_type);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.debug('Get Account error:', err.message);
            throw new Error(err);
          });
      }
    });
  }, []);
};

export default useAuthChanged;
